 <template>
  <r-form
    ref="rform"
    class="page"
    classContent="page-content full-height"
    :itemId="idData"
    @save="onSave"
    @loadItem="loadItem"
    :readonly="readonly"
    :dbAdapter="Cliente"
    :documentoAdapter="Documento"
    :defaultData="{instalaciones:[], canalesComunicacion:[], contactos:[], direcciones:[], condicionesPago: [], listaPrecios: 1, fechasPago: [], activo: true, cuentas: [], emailsFacturas: [], emailsCertificados: []}"
    :beforeSave="beforeSaveCliente"
  >
    <!-- Top Navbar -->
    <template v-slot:before="{rform}">
      <f7-popover ref="popo"
            @popover:open="removeEmptyOptions(rform.formData)"
            @popover:closed="removeEmptyOptions(rform.formData)">
        <f7-row class="cabecera-fechaPago">
          <f7-button
            icon-f7="plus"
            class="nueva-fecha"
            @click="nuevaOpcion(rform.formData.fechasPago)"
          ></f7-button>
        </f7-row>
        <f7-list class="limit-height" ref="fechaPagoList">
          <f7-list-input
            v-for="(fecha,ico) in rform.formData.fechasPago"
            :key="'fecha-' + fecha + '-fecha2-' + ico"
            type="number"
            step="1"
            min="1"
            max="31"
            placeholder="Día del mes"
            clear-button
            :value="fecha"
            @change="!$event.target.value? rform.formData.fechasPago.splice(ico, 1) : $set(rform.formData.fechasPago, ico, $event.target.value)"
          ></f7-list-input>
        </f7-list>
      </f7-popover>
      <f7-navbar>
        <f7-nav-left>
          <f7-link @click.stop="$f7router.back()">&lt; {{ $t('atras') }}</f7-link>
          <f7-button v-if="rform.canShowHistory" class="btn-historico" icon-f7="square_pencil" @click="rform.getHistory()"> Ver Histórico </f7-button>
        </f7-nav-left>
        <f7-nav-title v-if="idData && !readonly" sliding>{{$t('clientes.editar_cliente')}}</f7-nav-title>
        <f7-nav-title v-else-if="idData" sliding>{{$t('clientes.cliente')}}</f7-nav-title>
        <f7-nav-title v-else sliding>{{$t('clientes.nuevo_cliente')}}</f7-nav-title>
        <f7-nav-right>
          <f7-button
          v-if="readonly"
          fill
          :href="'/clientes/edit/' + idData + '/'"
          text="Editar"
          class="display-flex"

          ></f7-button>
          <f7-button
            v-if="!readonly"
            fill
            icon-f7="floppy_disk"
            text="Guardar"
            class="display-flex"
            @click="rform.saveItem()"
          ></f7-button>
          <template slot="right" v-if="idData && readonly">
            <div class="menu-item menu-item-dropdown bg-color-primary">
              <div class="menu-item-content"><i class="f7-icons">ellipsis_vertical</i></div>
              <div class="menu-dropdown menu-dropdown-right bg-color-primary">
                <div class="menu-dropdown-content bg-color-primary text-align-right">
                  <div
                    class="menu-dropdown-item menu-close pointer"
                    v-if="rform && rform.formData && rform.formData.codigo"
                    @click="popupListadoFacturasOpened = true"
                  >{{$t('Ver Facturas')}}</div>
                  <div v-roles="['ADMIN', 'ADMINISTRACION']" v-if="rform && rform.formData">
                    <div class="menu-dropdown-divider"></div>
                    <div class="menu-dropdown-item menu-close pointer text-color-yellow" v-if="rform.formData.bcId" @click="verEnBC(rform.formData.bcId)">{{ $t('pedidos.verEnBC') }}</div>
                    <div class="menu-dropdown-item menu-close pointer text-color-yellow" @click="enviarBC(idData)">{{ $t('pedidos.enviarBC') }}</div>
                    <div class="menu-dropdown-divider"></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </f7-nav-right>
      </f7-navbar>
    </template>
    <!-- Tabs -->
    <template v-slot:default="{rform}">
      <f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
        <div name="Datos Generales">
          <f7-link
            @click="showDetalle = !showDetalle"
            :tooltip="showDetalle ? 'Ocultar Detalle' : 'Mostrar Detalle'"
            :icon-f7="showDetalle ?'chevron_compact_up' : 'chevron_compact_down'"
            :title="showDetalle ? 'Ocultar Detalle' : 'Mostrar Detalle'"
            style="padding-left: 7px;font-size: 10px;float: right;"
          ></f7-link>
        </div>
        <f7-card-content v-show="showDetalle">
          <f7-row no-gap class="list list-form no-hairlines">
            <div class="label-group" :class="{'col-50': readonly, 'col-100': !readonly}">Datos Generales</div>
            <f7-button
              v-if="readonly"
              class="col-20"
              v-noroles="['ENAC', 'PRODUCCION']"
              icon-f7="rectangle_stack_person_crop_fill"
              @click="crearOportunidad"
            >Crear oportunidad</f7-button>
            <f7-button
              class="col-20"
              v-noroles="['ENAC', 'PRODUCCION']"
              icon-f7="calendar_circle"
              @click="popupTareaEditable = true; popupTareasOpened = true"
              v-if="readonly && id && $refs.rform && $refs.rform.formData && $refs.rform.formData.codigo"
            >Crear tarea</f7-button>
            <r-input
              class="col-15"
              floating-label
              :label="$t('clientes.codigo')"
              :form="rform"
              type="text"
              name="codigo"
              v-if="id"
              :readonly="true"
            ></r-input>
            <r-input
              class="col-15"
              floating-label
              outline
              :label="$t('clientes.nif')"
              :form="rform"
              type="text"
              name="nif"
              :validation="{isValid: str => {return validator.isEmpty(str, {ignore_whitespace:true}) || ValidationUtils.validateSpanishID(str)}, errorMessage: '* Introduzca un NIF válido'}"
            ></r-input>
            <r-input
              class="col-35"
              floating-label
              :label="$t('clientes.razonSocial')"
              :form="rform"
              type="text"
              name="razonSocial"
              :allMayus="true"
              :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* Introduzca una Razón Social'}"
            ></r-input>
            <r-input
              class="col-35"
              floating-label
              :label="$t('clientes.empresaMantenedora')"
              :form="rform"
              name="empresaMantenedora"
            ></r-input>
            <!-- <r-autocomplete
              :dbAdapter="GrupoCliente"
              class="col-25"
              floating-label
              :label="$t('clientes.grupocliente')"
              :form="rform"
              name="grupoCliente"
              labelProp="nombre"
              idProp="codigo"
              idFieldDetail="id"
            ></r-autocomplete> -->
            <r-autocomplete-m2m
              :dbAdapter="GrupoCliente"
              class="col-15"
              floating-label
              outline
              :label="$t('clientes.grupocliente')"
              :form="rform"
              name="gruposCliente"
              labelProp="nombre"
              :idProp="null"
              prefixProp="codigo"
              idFieldDetail="id"
              type="textarea"
              :lineBreak="true"
            ></r-autocomplete-m2m>

            <f7-column class="col-85">
              <f7-row no-gap>

                <r-input
                  class="col-15"
                  :label="$t('clientes.potencial')"
                  :form="rform"
                  type="check"
                  name="potencial"
                ></r-input>
                <r-input
                  class="col-15"
                  :label="$t('clientes.tipoCliente')"
                  :form="rform"
                  type="select"
                  name="tipoCliente"
                >
                  <option value="D">Directo</option>
                  <option value="I">Indirecto</option>
                </r-input>
                <r-input
                  class="col-15"
                  floating-label
                  :label="$t('clientes.fechaCaptacion')"
                  :form="rform"
                  type="datepicker"
                  name="fechaCaptacion"
                  :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit'} }"
                ></r-input>
                <r-input
                  class="col-15"
                  :label="$t('clientes.moneda')"
                  :form="rform"
                  type="select"
                  name="moneda"
                >
                  <option selected value="EUR">Euro</option>
                </r-input>
                <r-autocomplete
                  :dbAdapter="Cliente"
                  class="col-40"
                  floating-label
                  :label="$t('clientes.clienteIndirecto')"
                  :form="rform"
                  :name="'clienteIndirecto'"
                  labelProp="codigoNombre"
                  idProp="codigoNombre"
                  idFieldDetail="id"
                  :detailUrl="!rform.formData.clienteIndirecto ? undefined : ('#!/' + 'clientes' + '/view/' + (rform.formData.clienteIndirecto.split('-')[0].trim()) + '/')"
                  :shownFields="['codigo', 'razonSocial']"
                  :minLength="3"
                  :async="true"
                ></r-autocomplete>
                <r-input
                  class="col-100 medium-10"
                  :form="rform"
                  type="check"
                  :name="'activo'"
                  label="Activo"
                ></r-input>
                <r-input
                  class="col-100 medium-10"
                  :form="rform"
                  type="check"
                  :name="'esProveedor'"
                  label="Es Proveedor"
                ></r-input>
                <div class="col-80"> </div>
              </f7-row>
            </f7-column>


            <f7-row no-gap class="col-100 display-flex" style="background-color: bisque;border-radius: 5px;">
              <div class="label-group col-100" style="margin-top: 0;margin-bottom: 0;">{{$t('clientes.titular.title')}}</div>
              <r-input
                class="col-25"
                floating-label
                :label="$t('clientes.titular.nombre')"
                :form="rform"
                type="text"
                name="titular.nombre"
              ></r-input>
              <r-input
                class="col-50"
                floating-label
                :label="$t('clientes.titular.apellidos')"
                :form="rform"
                type="text"
                name="titular.apellidos"
              ></r-input>
              <r-input
                class="col-25"
                floating-label
                :label="$t('clientes.titular.nif')"
                :form="rform"
                type="text"
                name="titular.nif"
              ></r-input>
            </f7-row>
            <div class="label-group col-100">Impuestos</div>
            <r-input
              class="col-25"
              :label="$t('clientes.recargoEquivalencia')"
              :form="rform"
              type="check"
              name="recargoEquivalencia"
            ></r-input>
            <r-input
              class="col-25"
              :label="$t('clientes.impuestoDiferido')"
              :form="rform"
              type="check"
              name="impuestoDiferido"
            ></r-input>
            <r-input
              class="col-25"
              floating-label
              :label="$t('clientes.codigoOperacion347')"
              :form="rform"
              type="text"
              name="codigoOperacion347"
            ></r-input>
            <r-input
              class="col-25"
              floating-label
              :label="$t('clientes.operacionAseguradora347')"
              :form="rform"
              type="check"
              name="operacionAseguradora347"
            ></r-input>
            <r-autocomplete
              :dbAdapter="Empleado"
              class="col-25"
              floating-label
              label="Responsable"
              :form="rform"
              name="responsable"
              labelProp="nombre"
              prefixProp="username"
              idProp="username"
              idFieldDetail="id"
              :decorationConfig="{
                icon: 'rectangle_on_rectangle_angled',
                color: 'blue',
                tooltip: 'Histórico de responsables',
                action: mostrarHistoricoResponsables
              }"
            ></r-autocomplete>
            <r-autocomplete
              :dbAdapter="Empleado"
              class="col-25"
              floating-label
              label="Empleado Ventas"
              :form="rform"
              name="empleadoVentas"
              labelProp="nombre"
              prefixProp="username"
              idProp="username"
              idFieldDetail="id"
              :shownFields="['slpCode']"
              @change="changeEmpleado($event)"
              :decorationConfig="{
                icon: 'rectangle_on_rectangle_angled',
                color: 'blue',
                tooltip: 'Histórico de empleados de ventas',
                action: mostrarHistoricoEmpleadoVentas
              }"
            ></r-autocomplete>
            <r-autocomplete
              :dbAdapter="Empleado"
              class="col-25"
              floating-label
              label="Responsable Gestión Cobro"
              :form="rform"
              name="responsableGestionCobro.usernameResponsable"
              labelProp="nombre"
              idProp="username"
              prefixProp="username"
              idFieldDetail="id"
              :decorationConfig="{
                icon: 'rectangle_on_rectangle_angled',
                color: 'blue',
                tooltip: 'Histórico de responsables gestión cobro',
                action: mostrarHistoricoResponsableGestionCobro
              }"
            ></r-autocomplete>
            <r-input
              class="col-25"
              floating-label
              label="Cod. Carga"
              :form="rform"
              type="text"
              name="codCarga"
            ></r-input>
            <div v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.codigo" class="label-group col-75" style="margin-top: 10px;">Datos de pedidos</div>
            <r-dynamic-list
              v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.codigo"
              ref="rlist"
              :primary="['id','lineas.numero']"
              :dbAdapter="LineaPedido"
              :tableCode="'LINEAPEDIDOCLIENTE'"
              :tableMode="true"
              :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
              class="card full-height data-table width-100"
              classContent="card-content full-height"
              :controlsWidth="100"
              :searchOnInit="true"
              :shownFields="['cliente.codigo','lineas.numero']"
              :mandatoryFilter ="{ 'cliente##codigo': $refs.rform.formData.codigo }"
              :funcShowCheck="_ => { return false; }"
              :massiveActions="false"
              :mostrarBadgeFilters="false"
              style="margin-bottom: 2px;"
            >
              <template v-slot:optionsColumn="{ item }">
                  <f7-link v-tooltip="$t('common.ver') + ' Tarea'" icon-f7="eye" color="green" @click="popupTareaEditable = false; tareaId = item.id; popupTareasOpened = true"></f7-link>
                  <f7-link icon-f7="square_pencil" color="blue" @click="popupTareaEditable = true; tareaId = item.id; popupTareasOpened = true"></f7-link>
                  <f7-link icon-f7="trash" color="red" @click="$refs.rlist.deleteItem(item.id)"></f7-link>
              </template>
            </r-dynamic-list>
          </f7-row>
        </f7-card-content>
      </f7-card>
      <pre style="display:none;">{{rform.formData}}</pre>
      <div class="margin-horizontal">
        <f7-segmented raised class="elevation-6 width-100">
          <f7-button fill tab-link="#tab-canalesComunicacion" :tab-link-active="tabSelected === 'tab-canalesComunicacion'" @click="selectTab('tab-canalesComunicacion')">Canales Comunicación</f7-button>
          <f7-button fill tab-link="#tab-instalaciones" :tab-link-active="tabSelected === 'tab-instalaciones'" @click="selectTab('tab-instalaciones')">Instalaciones</f7-button>
          <f7-button fill tab-link="#tab-direcciones" :tab-link-active="tabSelected === 'tab-direcciones'" @click="selectTab('tab-direcciones')">Direcciones</f7-button>
          <f7-button fill tab-link="#tab-contactos" :tab-link-active="tabSelected === 'tab-contactos'" @click="selectTab('tab-contactos')">Contactos</f7-button>
          <f7-button fill tab-link="#tab-finanzas" :tab-link-active="tabSelected === 'tab-finanzas'" @click="selectTab('tab-finanzas')">Pago y Finanzas</f7-button>
          <f7-button fill tab-link="#tab-comentarios" :tab-link-active="tabSelected === 'tab-comentarios'" @click="selectTab('tab-comentarios')">Comentarios</f7-button>
          <f7-button fill tab-link="#tab-documentos" :tab-link-active="tabSelected === 'tab-documentos'" @click="selectTab('tab-documentos')">Documentación</f7-button>
          <f7-button v-noroles="['ENAC', 'PRODUCCION']" fill tab-link="#tab-tareas" :tab-link-active="tabSelected === 'tab-tareas'" @click="selectTab('tab-tareas')">Tareas</f7-button>
          <f7-button fill tab-link="#tab-oportunidades" :tab-link-active="tabSelected === 'tab-oportunidades'" @click="selectTab('tab-oportunidades')">Oportunidades</f7-button>
          <f7-button fill tab-link="#tab-emails" :tab-link-active="tabSelected === 'tab-emails'" @click="selectTab('tab-emails')">e-Mails</f7-button>
        </f7-segmented>
      </div>
      <f7-tabs class="full-height" style="overflow: auto;">
        <f7-tab id="tab-canalesComunicacion" tab-active>
          <template v-if="tabSelected === 'tab-canalesComunicacion'">
            <!-- Canales Comunicacion -->
            <f7-block-title v-if="$refs.rform && $refs.rform.formData" style="z-index: 30">
              {{$t('clientes.canalescomunicacion')}}
              <f7-link
                v-if="!rform.readonly && rform.formData"
                @click="rform.formData.canalesComunicacion.push({tipo: '', nombre: '', valor:''})"
              >{{$t('centrostrabajo.add')}}</f7-link>
            </f7-block-title>

            <div v-if="rform && rform.formData" style="z-index: 30">
              <f7-card
                class="elevation-3 padding-vertical-half padding-right"
                v-for="(item,index) in rform.formData.canalesComunicacion"
                :key="'canalcomunicacion-'+index"
                :style="'z-index:'+(rform.formData.canalesComunicacion.length - index)"
              >
                <f7-card-content>
                  <f7-list class="list-form">
                    <ul>
                      <f7-row>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('clientes.tipo')"
                          :form="rform"
                          type="select"
                          :name="'canalesComunicacion.' + index + '.tipo'"
                          :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* Este dato es obligatorio'}"
                        >
                          <option selected></option>
                          <option value="TELEFONO">{{$t('clientes.telefono')}}</option>
                          <option value="TELEFONO_MOVIL">{{$t('clientes.telefono_movil')}}</option>
                          <option value="FAX">{{$t('clientes.fax')}}</option>
                          <option value="EMAIL">{{$t('clientes.email')}}</option>
                          <option value="WEB">{{$t('clientes.web')}}</option>
                        </r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('clientes.nombre')"
                          :form="rform"
                          :name="'canalesComunicacion.' + index + '.nombre'"
                          :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* Este dato es obligatorio'}"
                        ></r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('clientes.valor')"
                          :form="rform"
                          :name="'canalesComunicacion.' + index + '.valor'"
                          :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* Este dato es obligatorio'}"
                        ></r-input>
                      </f7-row>
                    </ul>
                  </f7-list>
                </f7-card-content>
                <f7-link
                  v-if="!rform.readonly && rform.formData"
                  @click="$delete(rform.formData.canalesComunicacion,index);"
                  class="margin-half"
                  style="position:absolute;right:0;top:0;"
                  icon-f7="trash"
                ></f7-link>
              </f7-card>
            </div>
          </template>
        </f7-tab>
        <f7-tab id="tab-instalaciones">
          <template v-if="tabSelected === 'tab-instalaciones'">
            <div class="block-title" v-if="idData">
              Instalaciones
              <f7-link v-if="!rform.readonly" popup-open=".popup-instalacion">{{$t('clientes.add')}}</f7-link>
            </div>
            <div
              v-if="idData && rform.formData && rform.formData.instalaciones"
              class="list accordion-list accordion-opposite margin-left margin-right"
            >
              <ul>
                <li
                  class="accordion-item row"
                  v-for="(item,index) in rform.formData.instalaciones"
                  :key="'instalacion-'+index"
                  @accordion:open="openInstalacion(item)"
                >
                  <a class="col-95 item-content item-link" href="#">
                    <div class="item-inner">
                      <div class="item-title">{{item.codigo}} - {{item.nombre}}</div>
                    </div>
                  </a>
                  <f7-link
                    class="col-5"
                    style="margin-top:5px; margin-right:5px;"
                    icon-f7="minus_circle_fill"
                    color="red"
                    @click="borrarInstalacion(item.codigo)"
                  ></f7-link>
                  <div class="accordion-item-content">
                    <f7-row>
                      <r-input
                        class="col-50"
                        floating-label
                        :label="$t('clientes.codigo')"
                        :form="rform"
                        type="text"
                        :name="'instalaciones.' + index + '.codigo'"
                      ></r-input>
                      <r-input
                        class="col-50"
                        floating-label
                        :label="$t('clientes.nombre')"
                        :form="rform"
                        type="text"
                        :name="'instalaciones.' + index + '.nombre'"
                      ></r-input>
                    </f7-row>
                    <div class="block-title">Datos Instalación</div>
                    <f7-row>
                      <r-input
                        class="col-50"
                        floating-label
                        :label="$t('clientes.nif')"
                        :form="rform"
                        type="text"
                        :name="'instalaciones.' + index + '.datosInstalacion.nif'"
                      ></r-input>
                      <r-input
                        class="col-50"
                        floating-label
                        :label="$t('clientes.razonSocial')"
                        :form="rform"
                        type="text"
                        :name="'instalaciones.' + index + '.datosInstalacion.razonSocial'"
                      ></r-input>
                      <r-direccion
                        :form="rform"
                        :name="'instalaciones.' + index + '.datosInstalacion.direccion'"
                      ></r-direccion>
                    </f7-row>
                    <div class="block-title">
                      Titulares
                      <f7-link
                        v-if="!rform.readonly"
                        @click="if (!item.titulares) item.titulares = []; item.titulares.push({})"
                      >{{$t('clientes.add')}}</f7-link>
                    </div>
                    <div
                      v-if="item && (!item.titulares || item.titulares.length == 0)"
                      class="margin-left text-color-gray"
                    >No hay Titulares asociados a la instalación</div>
                    <div
                      v-if="item && item.titulares"
                      class="list accordion-list accordion-opposite margin-left"
                    >
                      <ul>
                        <li
                          class="accordion-item row"
                          v-for="(titular,indexTitulares) in item.titulares"
                          :key="'instalacion-' + index + '-titular-' + indexTitulares"
                          @accordion:beforeopen="openTitular"
                        >
                          <f7-link
                            class="col-5"
                            style="margin-top:5px; margin-right:5px;"
                            icon-f7="minus_circle_fill"
                            color="red"
                            @click="borrarTitular(item, titular)"
                          ></f7-link>
                          <a class="item-content item-link col-95" href="#">
                            <div class="item-inner">
                              <div class="item-title">{{titular.nif}} - {{titular.nombre}}</div>
                            </div>
                          </a>
                          <div class="accordion-item-content">
                            <f7-row>
                              <r-input
                                class="col-33"
                                floating-label
                                :label="$t('clientes.nif')"
                                :form="rform"
                                type="text"
                                :name="'instalaciones.' + index + '.titulares.' + indexTitulares + '.nif'"
                              ></r-input>
                              <r-input
                                class="col-33"
                                floating-label
                                :label="$t('clientes.nombre')"
                                :form="rform"
                                type="text"
                                :name="'instalaciones.' + index + '.titulares.' + indexTitulares + '.nombre'"
                              ></r-input>
                              <r-input
                                class="col-33"
                                floating-label
                                :label="$t('clientes.razonSocial')"
                                :form="rform"
                                type="text"
                                :name="'instalaciones.' + index + '.titulares.' + indexTitulares + '.razonSocial'"
                              ></r-input>
                              <r-direccion
                                :form="rform"
                                :name="'instalaciones.' + index + '.titulares.' + indexTitulares + '.direccion'"
                              ></r-direccion>
                            </f7-row>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="block-title">
                      Items
                      <f7-link v-if="!rform.readonly" popup-open=".popup-item">{{$t('clientes.add')}}</f7-link>
                    </div>
                    <div
                      v-if="!itemsInstalacion || itemsInstalacion.length == 0"
                      class="margin-left text-color-gray margin-bottom"
                    >No hay Items asociados a la Instalación</div>
                    <div class="list margin-bottom margin-left">
                      <ul>
                        <li
                          class="row"
                          v-for="(itemInstalacion, indexItems) in itemsInstalacion"
                          :key="'instalacion-' + index + '-item-' + indexItems"
                        >
                          <f7-link
                            class="col-5"
                            style="margin-top:5px; margin-right:5px;"
                            icon-f7="minus_circle_fill"
                            color="red"
                            @click="borrarItem(itemInstalacion.id)"
                          ></f7-link>
                          <a
                            :href="(readonly ? '/items/view/' : '/items/edit/') + itemInstalacion.id + '/'"
                            class="item-link item-content col-95"
                          >
                            <div class="item-inner">
                              <div
                                class="item-title"
                              >{{itemInstalacion.codigo}} - {{itemInstalacion.nombre}}</div>
                              <div class="item-after">Ver</div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </f7-tab>
        <f7-tab id="tab-direcciones">
          <template v-if="tabSelected === 'tab-direcciones'">
            <f7-list class="list-form">
              <ul class="margin-horizontal">
              <f7-row>
                <r-input
                  class="col-50"
                  :label="$t('clientes.direccionDefectoFacturas')"
                  :form="rform"
                  type="select"
                  name="direccionDefectoFacturas"
                >
                  <option
                    :key="'direccionDefectoFacturas-empty'"
                    :value="null"
                  >{{''}}</option>
                  <option
                    v-for="(item,index) in rform.formData.direcciones.filter(d => d.tipo == 'DESTINATARIO_FACTURA')"
                    :key="'direccionDefectoFacturas-'+index"
                    :value="item.alias"
                    :selected="item.alias == rform.formData.direccionDefectoFacturas"
                  >{{item.alias}}</option>
                </r-input>
                <r-input
                  class="col-50"
                  :label="$t('clientes.direccionDefectoEnvio')"
                  :form="rform"
                  type="select"
                  name="direccionDefectoEnvio"
                >
                  <option
                    :key="'direccionDefectoEnvio-empty'"
                    :value="null"
                  >{{''}}</option>
                  <option
                    v-for="(item,index) in rform.formData.direcciones.filter(d => d.tipo == 'ENVIAR_A')"
                    :key="'direccionDefectoEnvio-'+index"
                    :value="item.alias"
                    :selected="item.alias == rform.formData.direccionDefectoEnvio"
                  >{{item.alias}}</option>
                </r-input>
              </f7-row>
              </ul>
            </f7-list>
            <!-- Direcciones -->
            <f7-block-title v-if="$refs.rform && $refs.rform.formData" style="z-index: 30">
              {{$t('clientes.direcciones')}}
              <f7-link
                v-if="!rform.readonly && rform.formData"
                @click="rform.formData.direcciones.push({})"
              >{{$t('clientes.add')}}</f7-link>
            </f7-block-title>

            <div v-if="rform && rform.formData" style="z-index: 30">
              <f7-card
                class="elevation-3 padding-vertical-half padding-right"
                v-for="(item,index) in rform.formData.direcciones"
                :key="'direcciones-'+index"
                :style="'z-index:'+(rform.formData.direcciones.length - index)"
              >
                <f7-card-content>
                  <f7-list class="list-form">
                    <ul>
                      <f7-row>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('clientes.alias')"
                          :form="rform"
                          :name="'direcciones.' + index + '.alias'"
                          :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* Este dato es obligatorio'}"
                        ></r-input>
                        <!-- <r-input
                          class="col-33"
                          floating-label
                          :label="$t('clientes.nif')"
                          :form="rform"
                          :name="'direcciones.' + index + '.nif'"
                        ></r-input> -->
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('clientes.tipo')"
                          :form="rform"
                          type="select"
                          :name="'direcciones.' + index + '.tipo'"
                          :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* Este dato es obligatorio'}"
                        >
                          <option selected></option>
                          <option value="ENVIAR_A">{{$t('clientes.enviar_a')}}</option>
                          <option value="DESTINATARIO_FACTURA">{{$t('clientes.destinatario_factura')}}</option>
                        </r-input>
                        <r-direccion :form="rform" :name="'direcciones.' + index"></r-direccion>
                      </f7-row>
                    </ul>
                  </f7-list>
                </f7-card-content>
                <f7-link
                  v-tooltip="'Borrar Dirección'"
                  v-if="!rform.readonly && rform.formData"
                  @click="$delete(rform.formData.direcciones,index);"
                  class="margin-half link-inline link-inline-0"
                  style="position:absolute;right:0;top:0;"
                  icon-f7="trash"
                ></f7-link>
                <f7-link
                  v-tooltip="'Duplicar Dirección'"
                  v-if="!rform.readonly"
                  @click.prevent="rform.formData.direcciones.push(
                    JSON.parse(JSON.stringify( Object.assign({}, rform.formData.direcciones[index], {alias: ''}))))"
                  class="margin-half link-inline link-inline-1"
                  icon-f7="plus_square_fill_on_square_fill"
                ></f7-link>
              </f7-card>
            </div>

            <f7-card class="elevation-3 padding-vertical-half padding-right">
              <f7-card-content>
                <f7-list class="list-form">
                  <ul>
                    <f7-row>
                      <f7-block-title class="col-100">
                        Emails Envío Facturas
                        <f7-link v-if="!readonly" @click="addEmail('emailsFacturas')">{{$t('pedidos.add')}}</f7-link>
                        <f7-link
                          v-if="readonly && rform.formData && rform.formData.emailsFacturas && rform.formData.emailsFacturas.length"
                          external
                          v-tooltip="'Enviar Email'"
                          icon-f7="envelope_badge_fill"
                          :href="'mailto:' + rform.formData.emailsFacturas.join(';')"
                        ></f7-link>
                      </f7-block-title>
                      <div class="form-caja margin-horizontal" v-if="rform.formData">
                        <div
                          class="col-100"
                          v-for="(email, index) in rform.formData.emailsFacturas"
                          :key="'emailFactura-' + index"
                        >
                          <r-input
                            class="col-100"
                            outline
                            floating-label
                            :label="'Correo electrónico'"
                            :form="rform"
                            type="text"
                            :clearButton="false"
                            :placeholder="'Introduzca un correo electrónico válido'"
                            :name="'emailsFacturas.' + index"
                            :validation="{isValid: validator.isEmail, errorMessage: '* Introduzca un correo electrónico válido'}"
                          >
                            <f7-link
                              v-if="!readonly"
                              v-tooltip="'Borrar'"
                              slot="inner-end"
                              @click="$delete(rform.formData.emailsFacturas, index);"
                              class="input-suffix-btn"
                              icon-f7="trash"
                              style="top: initial;right: 15px;"
                            ></f7-link>
                          </r-input>
                        </div>
                      </div>
                    </f7-row>
                    <f7-row>
                      <f7-block-title class="col-100">
                        Emails Envío Certificados
                        <f7-link v-if="!readonly" @click="addEmail('emailsCertificados')">{{$t('pedidos.add')}}</f7-link>
                        <f7-link
                          v-if="readonly && rform.formData && rform.formData.emailsCertificados && rform.formData.emailsCertificados.length"
                          external
                          v-tooltip="'Enviar Email'"
                          icon-f7="envelope_badge_fill"
                          :href="'mailto:' + rform.formData.emailsCertificados.join(';')"
                        ></f7-link>
                      </f7-block-title>
                      <div class="form-caja margin-horizontal" v-if="rform.formData">
                        <div
                          class="col-100"
                          v-for="(email, index) in rform.formData.emailsCertificados"
                          :key="'emailCertificado-' + index"
                        >
                          <r-input
                            class="col-100"
                            outline
                            floating-label
                            :label="'Correo electrónico'"
                            :form="rform"
                            type="text"
                            :clearButton="false"
                            :placeholder="'Introduzca un correo electrónico válido'"
                            :name="'emailsCertificados.' + index"
                            :validation="{isValid: validator.isEmail, errorMessage: '* Introduzca un correo electrónico válido'}"
                          >
                            <f7-link
                              v-if="!readonly"
                              v-tooltip="'Borrar'"
                              slot="inner-end"
                              @click="$delete(rform.formData.emailsCertificados, index);"
                              class="input-suffix-btn"
                              icon-f7="trash"
                              style="top: initial;right: 15px;"
                            ></f7-link>
                          </r-input>
                        </div>
                      </div>
                    </f7-row>
                  </ul>
                </f7-list>
              </f7-card-content>
            </f7-card>
          </template>
        </f7-tab>
        <f7-tab id="tab-contactos">
          <template v-if="tabSelected === 'tab-contactos'">
            <f7-list class="list-form">
              <f7-row>
                <r-input
                  class="col-50"
                  :label="$t('clientes.contactoDefecto')"
                  :form="rform"
                  type="select"
                  name="contactoDefecto"
                >
                  <option
                    :key="'contactosDefecto-empty'"
                    :value="null"
                  >{{''}}</option>
                  <option
                    v-for="(item,index) in rform.formData.contactos"
                    :key="'contactosDefecto-'+index"
                    :value="item.alias"
                    :selected="item.alias == rform.formData.contactoDefecto"
                  >{{item.alias}}</option>
                </r-input>
              </f7-row>
            </f7-list>
            <!-- Contactos -->
            <f7-block-title v-if="$refs.rform && $refs.rform.formData" style="z-index: 30">
              {{$t('clientes.contactos')}}
              <f7-link
                v-if="!rform.readonly && rform.formData"
                @click="rform.formData.contactos.push({activo:true, canalesComunicacion:[]})"
              >{{$t('clientes.add')}}</f7-link>
            </f7-block-title>

            <div v-if="rform && rform.formData" style="z-index: 30">
              <f7-card
                class="elevation-3 padding-vertical-half padding-right"
                v-for="(item,index) in rform.formData.contactos"
                :key="'contactos-'+index"
                style="border: 1px solid yellowgreen;margin-bottom: 5px !important;"
                :style="'z-index:'+(rform.formData.contactos.length - index)"
              >
                <f7-card-content>
                  <f7-list class="list-form">
                    <ul>
                      <f7-row>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('clientes.alias')"
                          :form="rform"
                          :name="'contactos.' + index + '.alias'"
                          :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* Este dato es obligatorio'}"
                        ></r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('clientes.nombre')"
                          :form="rform"
                          :name="'contactos.' + index + '.nombre'"
                        ></r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('clientes.apellidos')"
                          :form="rform"
                          :name="'contactos.' + index + '.apellidos'"
                        ></r-input>
                        <f7-col class="col-33" style="padding: 0;">
                          <r-input
                            class="col-100"
                            floating-label
                            :label="$t('clientes.contacto.posicion')"
                            :form="rform"
                            :name="'contactos.' + index + '.posicion'"
                          ></r-input>
                          <r-input
                            class="col-100"
                            floating-label
                            :label="$t('clientes.contacto.dni')"
                            :form="rform"
                            :name="'contactos.' + index + '.dni'"
                          ></r-input>
                        </f7-col>
                        <r-direccion
                          :form="rform"
                          :name="'contactos.' + index + '.direccion'">
                        </r-direccion>
                        <r-input
                          class="col-33"
                          :label="$t('clientes.activo')"
                          :form="rform"
                          type="check"
                          :name="'contactos.' + index + '.activo'"
                        ></r-input>
                      </f7-row>
                    </ul>
                  </f7-list>
                  <!-- Canales Comunicacion -->
                  <f7-block-title style="z-index: 20">
                    {{$t('clientes.canalescomunicacion')}}
                    <f7-link
                      v-if="!rform.readonly && rform.formData"
                      @click="addCanalComunicacionContacto(index)"
                    >{{$t('centrostrabajo.add')}}</f7-link>
                  </f7-block-title>

                  <div style="z-index: 20">
                    <f7-card
                      class="elevation-3 padding-vertical-half padding-right"
                      v-for="(item2,index2) in rform.formData.contactos[index].canalesComunicacion"
                      :key="'contacto-'+index+'canalcomunicacion-'+index2"
                      :style="'z-index:'+(rform.formData.contactos[index].canalesComunicacion.length - index2)"
                    >
                      <f7-card-content>
                        <f7-list class="list-form">
                          <ul>
                            <f7-row>
                              <r-input
                                class="col-33"
                                floating-label
                                :label="$t('clientes.tipo')"
                                :form="rform"
                                type="select"
                                :name="'contactos.' + index + '.canalesComunicacion.' + index2 + '.tipo'"
                              >
                                <option selected></option>
                                <option value="TELEFONO">{{$t('clientes.telefono')}}</option>
                                <option value="TELEFONO_MOVIL">{{$t('clientes.telefono_movil')}}</option>
                                <option value="FAX">{{$t('clientes.fax')}}</option>
                                <option value="EMAIL">{{$t('clientes.email')}}</option>
                                <option value="WEB">{{$t('clientes.web')}}</option>
                              </r-input>
                              <r-input
                                class="col-33"
                                floating-label
                                :label="$t('clientes.nombre')"
                                :form="rform"
                                :name="'contactos.' + index + '.canalesComunicacion.' + index2 + '.nombre'"
                              ></r-input>
                              <r-input
                                class="col-33"
                                floating-label
                                :label="$t('clientes.valor')"
                                :form="rform"
                                :name="'contactos.' + index + '.canalesComunicacion.' + index2 + '.valor'"
                              ></r-input>
                            </f7-row>
                          </ul>
                        </f7-list>
                      </f7-card-content>
                      <f7-link
                        v-if="!rform.readonly && rform.formData"
                        @click="$delete(rform.formData.contactos[index].canalesComunicacion,index2);"
                        class="margin-half"
                        style="position:absolute;right:0;top:0;"
                        icon-f7="trash"
                      ></f7-link>
                    </f7-card>
                  </div>
                </f7-card-content>
                <f7-link
                  v-if="!rform.readonly && rform.formData"
                  @click="$delete(rform.formData.contactos,index);"
                  class="margin-half link-inline link-inline-0"
                  style="position:absolute;right:0;top:0;"
                  icon-f7="trash"
                ></f7-link>
                <f7-link
                  v-tooltip="'Duplicar Contacto'"
                  v-if="!rform.readonly"
                  @click.prevent="rform.formData.contactos.push(
                    JSON.parse(JSON.stringify( Object.assign({}, rform.formData.contactos[index], {alias: ''}))))"
                  class="margin-half link-inline link-inline-1"
                  icon-f7="plus_square_fill_on_square_fill"
                ></f7-link>
              </f7-card>
            </div>
            <f7-block-title v-if="$refs.rform && $refs.rform.formData" style="z-index: 30">
              {{$t('clientes.contactos')}}
              <f7-link
                v-if="!rform.readonly && rform.formData"
                @click="rform.formData.contactos.push({activo:true, canalesComunicacion:[]})"
              >{{$t('clientes.add')}}</f7-link>
            </f7-block-title>
          </template>
        </f7-tab>
        <f7-tab id="tab-finanzas">
          <template v-if="tabSelected === 'tab-finanzas'">
            <!-- Pago y Finanzas -->
            <f7-card class="elevation-3 padding-vertical-half padding-right">
              <f7-card-content>
                <f7-list class="list-form">
                  <ul>
                    <f7-row no-gap class="col-100 display-flex" style="background-color: plum; border-radius: 5px; margin-left: 15px;"> 
                      <div class="label-group col-100" style="margin-top: 0;margin-bottom: 0;">Facturación</div>
                      <f7-col col="20" >
                        <r-autocomplete
                          outline
                          ref="facturarComo"
                          class="col-20"
                          floating-label
                          label="Facturar como"
                          :form="rform"
                          :dbItems="facturarComo"
                          name="facturarComo"
                          labelProp="nombre"
                          idProp="valor"
                        ></r-autocomplete>
                      </f7-col>
                    </f7-row>
                    <f7-row no-gap class="col-100 display-flex"> 
                      <!-- <div class="label-group col-100" style="margin-top: 0;margin-bottom: 0;">{{$t('clientes.cuentasContables')}}</div> -->
                      <f7-col col="20" >
                        <r-autocomplete
                          :dbAdapter="ViaPago"
                          floating-label
                          label="Forma de pago"
                          :form="rform"
                          name="viaPagoDefecto"
                          labelProp="nombre"
                          idProp="codigo"
                          idFieldDetail="id"
                          outline
                          :filter="{ filter: { activa: true } }"
                        ></r-autocomplete>
                      </f7-col>
                      <f7-col col="20" >
                        <r-autocomplete
                          :dbAdapter="PlazoDias"
                          floating-label
                          label="Plazo días"
                          :form="rform"
                          name="plazoDias"
                          labelProp="dias"
                          idProp="dias"
                          idFieldDetail="id"
                          outline
                          :filter="{ filter: { activa: true } }"
                        ></r-autocomplete>
                      </f7-col>
                    </f7-row>
                    <f7-row> 
                      <f7-col col="50" >
                        <!-- Cuentas múltiples (badges) -->
                        <div class="label-group" style="width: 100%;">Cuentas (múltiple)</div>
                        <div class="col-100">
                          <div class="textarea-like cuentas-badges" @click="promptAddCuenta">
                            <span v-for="(cta, idx) in ($refs.rform && $refs.rform.formData ? ($refs.rform.formData.cuentas || []) : [])"
                                  :key="'cta-'+idx"
                                  :class="['badge','cuenta-badge', { 'invalid-iban': !isValidIban(cta) }]"
                                  v-tooltip="tooltipCuenta(cta)">
                              {{ cta && cta.iban ? cta.iban : cta }}
                              <i class="f7-icons remove" @click.stop="removeCuenta(idx)">xmark_circle_fill</i>
                            </span>
                            <span v-if="$refs.rform && $refs.rform.formData && (!$refs.rform.formData.cuentas || !$refs.rform.formData.cuentas.length)" class="placeholder">Haz click para añadir IBAN(es)</span>
                          </div>
                        </div>
                      </f7-col>
                      <div class="col-50 medium-50  cursor-pointer" @click="clickFechasPago($event.target)">
                        <r-input
                          outline
                          :label="$t('clientes.fechasPago')"
                          :form="rform"
                          :name="'fechasPago'"
                          type="textarea"
                          :readonly="true"
                        ></r-input>
                      </div>
                    </f7-row>
                  </ul>
                </f7-list>
              </f7-card-content>
            </f7-card>
          </template>
        </f7-tab>
        <f7-tab id="tab-comentarios">
          <template v-if="tabSelected === 'tab-comentarios'">
            <f7-card class="elevation-3 padding-vertical-half padding-right">
              <f7-card-content>
                <f7-list class="list-form">
                  <ul>
                    <f7-row>
                      <r-input
                        class="col-100"
                        :form="rform"
                        :name="'pestanaComentarios'"
                        type="textarea"
                    ></r-input>
                    </f7-row>
                  </ul>
                </f7-list>
              </f7-card-content>
            </f7-card>
          </template>
        </f7-tab>
        <f7-tab id="tab-documentos">
          <template v-if="tabSelected === 'tab-documentos'">
            <f7-card class="elevation-3 padding-vertical-half padding-right">
              <f7-card-content>
                <div v-if="(rform.formData.documentos && !rform.formData.documentos.length > 0) || !rform.formData.documentos" >El cliente no tiene documentos</div>
                <f7-list class="list-form">
                  <ul>
                    <r-files 
                      :form="rform" 
                      name="documentos"
                      :documentoAdapter="Documento"
                    ></r-files>
                  </ul>
                </f7-list>
              </f7-card-content>
            </f7-card>
          </template>
        </f7-tab>
        <f7-tab id="tab-tareas" v-noroles="['ENAC', 'PRODUCCION']">
          <template v-if="tabSelected === 'tab-tareas' && $refs.rform && $refs.rform.formData && $refs.rform.formData.codigo">
            <r-dynamic-list
              ref="rlistTareas"
              :primary="['id']"
              :dbAdapter="Tarea"
              :tableCode="'TAREASCLIENTE'"
              :tableMode="true"
              :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
              class="card full-height data-table"
              classContent="card-content full-height"
              :controlsWidth="100"
              :searchOnInit="true"
              :shownFields="['codigoCliente']"
              :mandatoryFilter ="{ 'codigoCliente': $refs.rform.formData.codigo }"
              :funcShowCheck="_ => { return false; }"
              :massiveActions="false"
            >
              <template v-slot:optionsColumn="{ item }">
                  <f7-link icon-f7="eye" color="green" @click="popupTareaEditable = false; tareaId = item.id; popupTareasOpened = true"></f7-link>
                  <f7-link icon-f7="square_pencil" color="blue" @click="popupTareaEditable = true; tareaId = item.id; popupTareasOpened = true"></f7-link>
                  <f7-link icon-f7="trash" color="red" @click="$refs.rlist.deleteItem(item.id)"></f7-link>
              </template>
            </r-dynamic-list>
          </template>
        </f7-tab>

        <f7-tab id="tab-oportunidades" v-noroles="['ENAC', 'PRODUCCION']">
          <template v-if="tabSelected === 'tab-oportunidades' && $refs.rform && $refs.rform.formData && $refs.rform.formData.codigo">
            <r-dynamic-list
              ref="rlistOportunidades"
              :primary="['id']"
              :dbAdapter="Oportunidad"
              :tableCode="'OPORTUNIDADTAB'"
              :tableMode="true"
              :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
              class="card full-height data-table"
              classContent="card-content full-height"
              :controlsWidth="50"
              :searchOnInit="true"
              :shownFields="['cliente.codigo']"
              :mandatoryFilter ="{ 'cliente##codigo': $refs.rform.formData.codigo }"
              :funcShowCheck="_ => { return false; }"
              :massiveActions="false"
            >
              <template v-slot:optionsColumn="{ item }">
                  <f7-link external v-tooltip="$t('common.ver') + ' Oportunidad'" icon-f7="eye" color="green" :href="`#!/oportunidades/view/${item.id}/`"></f7-link>
              </template>
            </r-dynamic-list>
          </template>
        </f7-tab>

        <f7-tab id="tab-emails">
          <template v-if="tabSelected === 'tab-emails' && $refs.rform && $refs.rform.formData && $refs.rform.formData.codigo">
            <r-dynamic-list
              ref="rlistEmails"
              :primary="['id']"
              :dbAdapter="RegistroEmail"
              :tableCode="'REGISTROEMAILTABS'"
              :tableMode="true"
              :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
              class="card full-height data-table"
              classContent="card-content full-height"
              :controlsWidth="50"
              :searchOnInit="true"
              :shownFields="['to','datos']"
              :mandatoryFilter ="{ 'datos##codigoCliente': $refs.rform.formData.codigo }"
              :funcShowCheck="_ => { return false; }"
              :massiveActions="false"
              useView="vista_RegistroEmails"
            >
              <template v-slot:optionsColumn="{ item }">
                  <f7-link icon-f7="eye" color="green" @click="popupEmailEditable = false; emailId = item.id; popupEmailOpened = true"></f7-link>
              </template>
            </r-dynamic-list>
          </template>
        </f7-tab>
      </f7-tabs>
      <r-form
        ref="rformInstalacion"
        v-slot="{rform}"
        :itemId="null"
        @save="onSaveInstalacion"
        :readonly="readonly"
        :dbAdapter="Instalacion"
        :beforeSave="beforeSaveInstalacion"
      >
        <f7-popup ref="popupInstalacion" class="popup-instalacion" swipe-to-close>
          <f7-page>
            <f7-navbar title="Instalación">
              <f7-nav-right></f7-nav-right>
            </f7-navbar>

            <!-- <div style="height: 100%" class="display-flex justify-content-center align-items-center"> -->
            <f7-card class="elevation-3 padding-vertical-half padding-right">
              <f7-card-content>
                <f7-list class="list-form">
                  <ul>
                    <f7-row>
                      <f7-col width="100" medium="100">
                        <r-input
                          class="col-50"
                          floating-label
                          :label="$t('clientes.codigo')"
                          :form="rform"
                          type="text"
                          name="codigo"
                        ></r-input>
                        <r-input
                          class="col-50"
                          floating-label
                          :label="$t('clientes.nombre')"
                          :form="rform"
                          type="text"
                          name="nombre"
                        ></r-input>
                      </f7-col>
                    </f7-row>
                  </ul>
                </f7-list>
              </f7-card-content>
              <f7-row>
                <f7-col width="100" medium="100">
                  <f7-button
                    fill
                    icon-f7="save"
                    text="Guardar Instalación"
                    class="display-flex margin-left"
                    color="green"
                    @click="$refs.rformInstalacion.saveItem()"
                  ></f7-button>
                </f7-col>
              </f7-row>
            </f7-card>
            <!-- </div> -->
          </f7-page>
        </f7-popup>
      </r-form>
      <r-form
        ref="rformItem"
        v-slot="{rform}"
        :itemId="null"
        @save="onSaveItem"
        :readonly="readonly"
        :dbAdapter="Item"
        :beforeSave="beforeSaveItem"
      >
        <f7-popup ref="popupItem" class="popup-item" swipe-to-close>
          <f7-page>
            <f7-navbar title="Item">
              <f7-nav-right></f7-nav-right>
            </f7-navbar>

            <!-- <div style="height: 100%" class="display-flex justify-content-center align-items-center"> -->
            <f7-card class="elevation-3 padding-vertical-half padding-right">
              <f7-card-content>
                <f7-list class="list-form">
                  <ul>
                    <f7-row>
                      <f7-col width="100" medium="100">
                        <r-input
                          floating-label
                          :label="$t('clientes.codigo')"
                          :form="rform"
                          type="text"
                          name="codigo"
                        ></r-input>
                        <r-input
                          floating-label
                          :label="$t('clientes.nombre')"
                          :form="rform"
                          type="text"
                          name="nombre"
                        ></r-input>
                        <r-autocomplete
                          :dbAdapter="Formato"
                          floating-label
                          :label="$t('clientes.formato')"
                          :form="rform"
                          name="formato"
                          nameId="formatoId"
                          labelProp="nombre"
                          idProp="id"
                        ></r-autocomplete>
                      </f7-col>
                    </f7-row>
                  </ul>
                </f7-list>
              </f7-card-content>
              <f7-row>
                <f7-col width="100" medium="100">
                  <f7-button
                    fill
                    icon-f7="save"
                    text="Guardar Item"
                    class="display-flex margin-left"
                    color="green"
                    @click="$refs.rformItem.saveItem()"
                  ></f7-button>
                </f7-col>
              </f7-row>
            </f7-card>
            <!-- </div> -->
          </f7-page>
        </f7-popup>
      </r-form>
      <f7-popup ref="popupTarea" swipe-to-close :opened="true" v-if="popupTareasOpened" @popup:closed="popupTareasOpened = false; tareaId = null">
        <tarea-form :id="tareaId" :editable="popupTareaEditable" @close="$refs.popupTarea.close();"  
          :defaultData="{ codigoCliente: $refs.rform.formData.codigo, estado: 'REALIZADA', fechaFecha: new Date(), fechaHora: new Date() }" :esPopup="true"
        ></tarea-form>
      </f7-popup>
      <f7-popup ref="popupEmail" swipe-to-close :opened="true" v-if="popupEmailOpened" @popup:closed="popupEmailOpened = false; emailId = null">
        <registro-email-form :id="emailId" :editable="popupEmailEditable" @close="$refs.popupEmail.close();"  
          :defaultData="{ codigoCliente: $refs.rform.formData.codigo, estado: 'REALIZADA', fechaFecha: new Date(), fechaHora: new Date() }" :esPopup="true"
        ></registro-email-form>
      </f7-popup>

      <!-- Popup Histórico Responsables -->
      <f7-popup 
        v-if="popupHistoricoResponsablesOpened" 
        :opened="true" 
        @popup:closed="popupHistoricoResponsablesOpened = false"
        ref="popupHistoricoResponsables"
        class="popupHistoricoResponsables"
      >
        <f7-page>
          <f7-navbar>
            <f7-nav-left></f7-nav-left>
            <f7-nav-title>Histórico de Responsables</f7-nav-title>
          </f7-navbar>
          <template>
            <f7-list>
              <f7-row no-gap style="text-align:center;font-weight: bold;" class="list_popup row-header">
                <span class="col-40">Responsable</span>
                <span class="col-30">Username</span>
                <span class="col-30">Fecha</span>
              </f7-row>
              <f7-row
                no-gap
                v-for="(item, index) in getHistoricoResponsables()"
                :key="'historicoResponsables-' + index"
                :class="'list_popup ' + (index % 2 == 0 ? 'row-even' : 'row-odd')"
              >
                <f7-list-input
                  :value="item.responsable"
                  v-tooltip="item.responsable"
                  :readonly="true"
                  class="col-40"
                  type="text"
                />
                <f7-list-input
                  :value="item.username"
                  v-tooltip="item.username"
                  :readonly="true"
                  class="col-30"
                  type="text"
                />
                <f7-list-input
                  :value="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
                  v-tooltip="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
                  :readonly="true"
                  class="col-30"
                  type="text"
                />
              </f7-row>
            </f7-list>
          </template>
        </f7-page>
      </f7-popup>

      <!-- Popup Histórico Empleado Ventas -->
      <f7-popup 
        v-if="popupHistoricoEmpleadoVentasOpened" 
        :opened="true" 
        @popup:closed="popupHistoricoEmpleadoVentasOpened = false"
        ref="popupHistoricoEmpleadoVentas"
        class="popupHistoricoEmpleadoVentas"
      >
        <f7-page>
          <f7-navbar>
            <f7-nav-left></f7-nav-left>
            <f7-nav-title>Histórico de Empleados de Ventas</f7-nav-title>
          </f7-navbar>
          <template>
            <f7-list>
              <f7-row no-gap style="text-align:center;font-weight: bold;" class="list_popup row-header">
                <span class="col-40">Empleado Ventas</span>
                <span class="col-30">Username</span>
                <span class="col-30">Fecha</span>
              </f7-row>
              <f7-row
                no-gap
                v-for="(item, index) in getHistoricoEmpleadoVentas()"
                :key="'historicoEmpleadoVentas-' + index"
                :class="'list_popup ' + (index % 2 == 0 ? 'row-even' : 'row-odd')"
              >
                <f7-list-input
                  :value="item.empleadoVentas"
                  v-tooltip="item.empleadoVentas"
                  :readonly="true"
                  class="col-40"
                  type="text"
                />
                <f7-list-input
                  :value="item.username"
                  v-tooltip="item.username"
                  :readonly="true"
                  class="col-30"
                  type="text"
                />
                <f7-list-input
                  :value="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
                  v-tooltip="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
                  :readonly="true"
                  class="col-30"
                  type="text"
                />
              </f7-row>
            </f7-list>
          </template>
        </f7-page>
      </f7-popup>

      <!-- Popup Histórico Responsable Gestión Cobro -->
      <f7-popup 
        v-if="popupHistoricoResponsableGestionCobroOpened" 
        :opened="true" 
        @popup:closed="popupHistoricoResponsableGestionCobroOpened = false"
        ref="popupHistoricoResponsableGestionCobro"
        class="popupHistoricoResponsableGestionCobro"
      >
        <f7-page>
          <f7-navbar title="Histórico de Responsables Gestión Cobro">
            <f7-nav-right>
              <f7-link popup-close>Cerrar</f7-link>
            </f7-nav-right>
          </f7-navbar>
          <template v-if="getHistoricoResponsableGestionCobro().length > 0">
            <f7-list class="list_popup row-header">
              <f7-row no-gap>
                <f7-list-input :readonly="true" class="col-40" type="text" value="Responsable" />
                <f7-list-input :readonly="true" class="col-30" type="text" value="Usuario" />
                <f7-list-input :readonly="true" class="col-30" type="text" value="Fecha" />
              </f7-row>
            </f7-list>
            <f7-list
              v-for="(item, index) in getHistoricoResponsableGestionCobro()"
              :key="'historicoResponsableGestionCobro-' + index"
              class="list_popup"
              :class="index % 2 === 0 ? 'row-even' : 'row-odd'"
            >
              <f7-row no-gap>
                <f7-list-input
                  :value="item.usernameResponsable"
                  v-tooltip="item.usernameResponsable"
                  :readonly="true"
                  class="col-40"
                  type="text"
                />
                <f7-list-input
                  :value="item.username"
                  v-tooltip="item.username"
                  :readonly="true"
                  class="col-30"
                  type="text"
                />
                <f7-list-input
                  :value="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
                  v-tooltip="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
                  :readonly="true"
                  class="col-30"
                  type="text"
                />
              </f7-row>
            </f7-list>
          </template>
        </f7-page>
      </f7-popup>

      <!-- Popup Listado Facturas -->
      <f7-popup tablet-fullscreen ref="popupListadoFacturas" class="popup-listado-facturas" :opened="popupListadoFacturasOpened" v-if="popupListadoFacturasOpened && $refs.rform && $refs.rform.formData && $refs.rform.formData.codigo" @popup:closed="popupListadoFacturasOpened = false;" swipe-to-close>
        <Facturas :search-on-init="true" :is-popup="true" :shown-fields="['cliente.codigo']" :mandatory-filter="{ 'cliente##codigo': $refs.rform.formData.codigo }" :ignore-table-filters="true"/>
      </f7-popup>
    </template>
  </r-form>
</template>
<style scoped>
.limit-height {
  overflow: auto;
  margin-top: 28px;
  max-height: 408px;
}
.cabecera-fechaPago {
  position:absolute;
  top: 0;
  z-index: 100;
  width: 100%;
  background: white;
  border-radius: 4px 4px 0 0;
  border-width: 0 0 1px;
  border-style: solid;
  border-color: #ddd;
  text-align: center;
}
.nueva-fecha {
  width:100%
}
ul.no-padding ul {
  padding: 0 !important;
}
li.accordion-item .card, li.accordion-item .card ul, .border-3, li.accordion-item .accordion-item-content {
  border-radius: 20px;
}
.border-3 {
  border: 3px solid;
}
.label-group {
  margin-top: 12px;
  margin-left: 20px;
  font-weight: bold;
  /* width:100%; */
}
.label-group-inspeccion {
  margin-top: 30px;
}
label.btn {
  padding: 1px;
  cursor: pointer;
  border: 1px solid;
}
.link-inline {
  position: absolute;
  top:0;
}
.link-inline-0 {
  right:0;
}
.link-inline-1 {
  right:25px;
}
.link-inline-2 {
  right:50px;
}
.over-card {
  position: absolute;
  top: -10px;
  z-index: 3000;
  left: 12px;
}
.item-inner.col-100{
  width: 100%;
  display: block;
  padding: 0;
}

.label-group {
  margin-top: 12px;
  margin-left: 20px;
  font-weight: bold;
}
.label-group-inspeccion {
  margin-top: 30px;
}
label.btn {
  padding: 1px;
  cursor: pointer;
  border: 1px solid;
}
.tab-link-active .item-media,
.accordion-item-opened .accordion-item-toggle .item-media {
  color: var(--f7-theme-color) !important;
}

.label-radio {
  width: var(--f7-radio-size);
  text-align: center;
}
label.radio.disabled,
label.item-checkbox.disabled {
  opacity: 1 !important;
}
.radio input[type="radio"]:not(:checked) ~ * {
  opacity: 0.2;
}

.page-content::after {
  content: "";
  opacity: 0.5;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}
.list ul {
  background: rgba(255, 255, 255, 0.7);
}

.tab-link-active {
  background-color: var(--f7-theme-color-shade) !important;
}

.accordion-item {
  background-color: #f3f3f3;
}
.accordion-item.inactive,
.accordion-item.inactive ul {
  background-color: #fad0d0;
}
.accordion-item-content {
  background-color: white;
}
/* Cuentas múltiples estilo textarea con badges */
.textarea-like.cuentas-badges {
  min-height: 64px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px;
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.cuenta-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--f7-theme-color);
  color: #fff;
  padding: 4px 8px;
  border-radius: 14px;
  font-size: 12px;
}
.cuenta-badge .remove {
  font-size: 14px;
  cursor: pointer;
}
.cuenta-badge.invalid-iban {
  background: #e74c3c;
}
.cuentas-badges .placeholder {
  color: #888;
  font-style: italic;
}
</style>
<style>

.popover-inner {
  position:relative;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer textarea{
  cursor: pointer;
}
</style>
<script>
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rFiles from "./../../components/rFiles.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";
import rAutocompleteM2m from "./../../components/rAutocompleteM2m.vue";
import rDireccion from "./../../components/rDireccion.vue";
import rCuenta from "./../../components/rCuenta.vue";
import rTimepicker from "./../../components/rTimepicker.vue";
import Cliente from "./../../js/db/Cliente.js";
import Item from "./../../js/db/Item.js";
import Formato from "./../../js/db/Formato.js";
import GrupoCliente from "./../../js/db/GrupoCliente.js";
import EmpresaMantenedora from "./../../js/db/EmpresaMantenedora.js";
import ListaPrecio from "./../../js/db/ListaPrecio.js";
import CondicionPago from "./../../js/db/CondicionPago.js";
import ViaPago from "./../../js/db/ViaPago.js";
import PlazoDias from "./../../js/db/PlazoDias.js";
import Instalacion from "./../../js/db/Instalacion.js";
import Comunidad from "./../../js/db/Comunidad.js";
import validator from "validator";
import Empleado from "./../../js/db/Empleado.js";
import ValidationUtils from "./../../js/ValidationUtils.js";
import Utils from "./../../js/Utils.js";
import DateUtils from "./../../js/DateUtils.js";
import Documento from "./../../js/db/Documento.js";
import Tarea from "./../../js/db/Tarea.js";
import TareaForm from "./../tareas/tarea-form.vue";
import RegistroEmail from "../../js/db/RegistroEmail.js";
import RegistroEmailForm from "./../registroemail/registroemail-form.vue";
import Oportunidad from "./../../js/db/Oportunidad.js";
import rDynamicList from "./../../components/rDynamicList.vue";
import LineaPedido from "./../../js/db/LineaPedido.js";
import Facturas from "../facturas/facturas.vue";
import Combos from "./../../js/db/Combos.js";

export default {
  components: {
    rForm,
    rInput,
    rTimepicker,
    rFiles,
    rAutocomplete,
    rAutocompleteM2m,
    rDireccion,
    rCuenta,
    TareaForm,
    RegistroEmailForm,
    rDynamicList,
    Facturas
  },
  data: function() {
    var self = this;
    return {
      Cliente,
      Tarea,
      RegistroEmail,
      Oportunidad,
      Item,
      Documento,
      Formato,
      GrupoCliente,
      EmpresaMantenedora,
      ListaPrecio,
      CondicionPago,
      ViaPago,
      PlazoDias,
      Instalacion,
      Comunidad,
      validator,
      LineaPedido,
      readonly: !this.editable,
      itemsInstalacion: [],
      isTitularOpen: false,
      openedInstalacion: {},
      condicionesPagoActivas: [],
      idData: null,
      Empleado,
      ValidationUtils,
      Utils,
      DateUtils,
      viasPagoSeleccionadas: [],
      popupTareasOpened: false,
      tareaId: null,
      popupTareaEditable: false,
      popupEmailOpened: false,
      emailId: null,
      popupEmailEditable: false,
      showDetalle: true,
      // popups para históricos
      popupHistoricoResponsablesOpened: false,
      popupHistoricoEmpleadoVentasOpened: false,
      popupHistoricoResponsableGestionCobroOpened: false,
      tabSelected: 'tab-canalesComunicacion',
      popupListadoFacturasOpened: false,
      facturarComo: [],
    };
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: { 
  },
  watch: {
    tabSelected(newValue, oldValue) {
        if (newValue !== oldValue) {
            this.$nextTick(() => {
                this.$f7.preloader.hide();
            });
        }
    }
  },
  beforeDestroy() {},
  methods: {
    selectTab(tabName) {
        if (this.tabSelected !== tabName) {
            this.$f7.preloader.show();
            this.tabSelected = tabName;
        }
    },
    crearOportunidad() {
      const self = this;
      self.$f7.dialog.confirm('¿Está seguro de que desea crear una oportunidad?', 'Crear oportunidad', () => {
        Oportunidad.save({
          data: {cliente: {id: self.$refs.rform.formData.id}, gestor: Utils.getUser().username}
        }).then(res => {
          self.$f7.dialog.alert("Creada oportunidad " + res.codigo);
          window.open('#!/oportunidades/view/' + res.id + '/', "_blank");
        });
      });
    },
    clickFechasPago(target) {
      const self = this;
      self.$refs.popo.open(target);
    },
    nuevaOpcion(opciones){
      var self = this;
      opciones.push('');
      var lista = self.$refs.fechaPagoList.$el;
      setTimeout(_=>{lista.scrollTop = lista.scrollHeight;},100); // Ñapa necesaria porque esto no es buena praxis. 
    },
    removeEmptyOptions(cliente){
      var self = this;
      self.$set(cliente, "fechasPago", cliente.fechasPago.filter(fecha => !!fecha));
    },
    promptAddCuenta: function(){
      const self = this;
      const app = self.$f7;
      app.dialog.prompt('Introduce IBAN(es) separados por ;', 'Añadir cuentas', function (val) {
        if(val == null){ return; }
        const nuevos = (val || '')
          .split(';')
          .map(s => (s || '').trim())
          .filter(s => !!s)
          .map(iban => iban.replace(/\s+/g, '').toUpperCase())
          .map(iban => ({ iban }));
        const actuales = (self.$refs.rform.formData.cuentas || []).slice();
        // normalizar actuales a objetos {iban}
        const actualesNorm = actuales.map(c => (typeof c === 'string' ? { iban: c } : c)).filter(c => c && c.iban);
        nuevos.forEach(n => { if(!actualesNorm.some(a => a.iban === n.iban)) { actualesNorm.push(n); } });
        self.$set(self.$refs.rform.formData, 'cuentas', actualesNorm);
      });
    },
    tooltipCuenta: function(cta) {
      const self = this;
      if (!self.isValidIban(cta)) { return 'IBAN inválido'; }
      const cuenta = typeof cta === 'string' ? { iban: cta } : cta;
      const partes = [];
      if (cuenta.nombreBanco) { partes.push(cuenta.nombreBanco); }
      if (cuenta.swift) { partes.push('SWIFT: ' + cuenta.swift); }
      if (!partes.length) { partes.push('Entidad: ' + (cuenta.iban || '').substring(4, 8)); }
      return partes.join(' | ');
    },
    isValidIban: function(cta){
      const self = this;
      const iban = typeof cta === 'string' ? cta : ((cta && cta.iban) ? cta.iban : '');
      if(!iban){ return false; }
      try {
        return self.validator.isIBAN(iban);
      } catch(e) {
        return false;
      }
    },
    removeCuenta: function(index){
      const self = this;
      const cuentas = (self.$refs.rform.formData.cuentas || []).slice();
      if(index >= 0 && index < cuentas.length){
        cuentas.splice(index, 1);
        self.$set(self.$refs.rform.formData, 'cuentas', cuentas);
      }
    },
    addEmail: function(listName) {
      var self = this;
      var arr = self.$refs.rform.formData[listName] || [];
      arr.push("");
      self.$set(self.$refs.rform.formData, listName, arr);
    },
    changeEmpleado: function(empleado) {
      var self = this;
      var app = self.$f7;
      if (empleado && empleado.idSap) {
        self.$set(self.$refs.rform.formData, 'empleadoVentasSlpCode', empleado.slpCode)
      } 
    },
    addCanalComunicacionContacto: function(index) {
      const self = this;
      var formData = self.$refs.rform.formData;
      var canales = formData.contactos[index].canalesComunicacion || [];
      canales.push({tipo: '', nombre: '', valor:''});
      self.$set(self.$refs.rform.formData.contactos[index], 'canalesComunicacion', canales);
    },
    borrarItem: function(id) {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        "Eliminar",
        function() {
          Item.delete({ itemId: id })
            .then(function(res) {
              if (res) {
                self.itemsInstalacion = self.itemsInstalacion.filter(
                  i => i.id != id
                );
                app.toast
                  .create({
                    icon: '<i class="f7-icons">checkmark</i>',
                    text: self.$t("rlist.registro_eliminado"),
                    position: "center",
                    destroyOnClose: true,
                    closeTimeout: 2000
                  })
                  .open();
              }
            })
            .catch(function(error) {
              app.dialog.alert(error.message);
            });
        }
      );
    },
    borrarTitular: function(instalacion, titular) {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        "Eliminar",
        function() {
          instalacion.titulares = instalacion.titulares.filter(
            t => t.nif != titular.nif
          );
        }
      );
    },
    borrarInstalacion: function(codigo) {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        "Eliminar",
        function() {
          Instalacion.delete({ clienteId: self.idData, codigo: codigo })
            .then(function(res) {
              if (res) {
                self.$refs.rform.formData = res;
                app.toast
                  .create({
                    icon: '<i class="f7-icons">checkmark</i>',
                    text: self.$t("rlist.registro_eliminado"),
                    position: "center",
                    destroyOnClose: true,
                    closeTimeout: 2000
                  })
                  .open();
              }
            })
            .catch(function(error) {
              app.dialog.alert(error.message);
            });
        }
      );
    },
    openTitular: function(event) {
      var self = this;
      self.isTitularOpen = true;
    },
    openInstalacion: function(instalacion) {
      var self = this;
      var app = self.$f7;
      if (self.isTitularOpen) {
        self.isTitularOpen = false;
        return;
      }
      self.itemsInstalacion = [];
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      self.openedInstalacion = instalacion;
      var params = {
        filter: {
          idCliente: self.idData,
          codigoInstalacionEq: instalacion.codigo
        }
      };
      Item.getList(params)
        .then(function(res) {
          self.itemsInstalacion = res.list;
        })
        .catch(function(e) {
          if (typeof e == "string") e = { error: e };
          let error = e.error || e.error_description;
          app.toast
            .create({
              text: error,
              position: "center",
              closeTimeout: 2000
            })
            .open();
        })
        .then(function() {
          espera.cerrar();
        });
    },
    loadItem: function(res) {
      var self = this;
      if (!res.instalaciones || res.instalaciones == null) {
        self.$set(self.$refs.rform.formData, "instalaciones", []);
      }
      if (!res.canalesComunicacion || res.canalesComunicacion == null) {
        self.$set(self.$refs.rform.formData, "canalesComunicacion", []);
      }
      if (!res.direcciones || res.direcciones == null) {
        self.$set(self.$refs.rform.formData, "direcciones", []);
      }
      if (!res.contactos || res.contactos == null) {
        self.$set(self.$refs.rform.formData, "contactos", []);
      }
      console.log("loadItem", res.condicionesPago, res.viasPago);
      if (!res.condicionesPago || res.condicionesPago == null) {
        self.$set(self.$refs.rform.formData, "condicionesPago", []);
      }
      if (!res.viasPago || res.viasPago == null) {
        self.$set(self.$refs.rform.formData, "viasPago", []);
      }
      if (!res.emailsFacturas || res.emailsFacturas == null) {
        self.$set(self.$refs.rform.formData, "emailsFacturas", []);
      }
      const emailsCertificados = (res.emailsCertificados != null ? res.emailsCertificados : res.emailsCertificados) || [];
      self.$set(self.$refs.rform.formData, "emailsCertificados", emailsCertificados);
      // Inicialización y normalización de cuentas múltiples
      if (!res.cuentas || res.cuentas == null) {
        self.$set(self.$refs.rform.formData, "cuentas", []);
      } else {
        // Normaliza posibles formatos anteriores (string con ';' o array de strings) a [{iban, ...}] conservando el resto de campos
        let cuentas = res.cuentas;
        const toClean = (iban) => (iban || '').replace(/\s+/g, '').toUpperCase();
        if (typeof cuentas === 'string') {
          cuentas = cuentas.split(';').map(s => toClean(s)).filter(Boolean).map(iban => ({ iban }));
        }
        if (Array.isArray(cuentas)) {
          cuentas = cuentas.map(c => {
            if (typeof c === 'string') return { iban: toClean(c) };
            return { ...c, iban: toClean(c.iban) };
          }).filter(c => c.iban);
          // Eliminar duplicados por iban, conservando la primera aparición
          const seen = new Set();
          cuentas = cuentas.filter(c => { if (seen.has(c.iban)) return false; seen.add(c.iban); return true; });
        } else {
          cuentas = [];
        }
        self.$set(self.$refs.rform.formData, 'cuentas', cuentas);
      }
    },
    beforeSaveInstalacion: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      var formData = data;
      formData.clienteId = self.idData;
      resolve(formData);
    },
    beforeSaveItem: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      var formData = data;
      formData.clienteId = self.idData;
      formData.codigoInstalacion = self.openedInstalacion.codigo;
      resolve(formData);
    },
    onSaveItem: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      if (!self.itemsInstalacion) {
        self.itemsInstalacion = [];
      }
      self.itemsInstalacion.push(res);
      self.$refs.rformItem.clear();
      if (self.$refs.popupItem) {
        self.$refs.popupItem.close();
      }
      app.toast
        .create({
          text: self.$t("items.item_guardado"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    },
    onSaveInstalacion: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      self.$refs.rformInstalacion.clear();
      if (self.$refs.popupInstalacion) {
        self.$refs.popupInstalacion.close();
      }
      if (self.$refs.rform && self.$refs.rform.formData) {
        var formData = self.$refs.rform.formData;
        formData.instalaciones.push(res);
      }
      app.toast
        .create({
          text: self.$t("clientes.cliente_guardado"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    },
    onSave: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      self.$refs.rform.formData = res;
      self.idData = res.id;
      app.toast
        .create({
          text: self.$t("clientes.cliente_guardado"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    },
    beforeSaveCliente: function(data, resolve, reject) {
      const self = this;
      const app = self.$f7;
      const normalizeEmails = (emails) => {
        if (!Array.isArray(emails)) {
          return [];
        }
        return emails
          .map(email => (email || '').trim())
          .filter(email => !!email);
      };

      data.emailsFacturas = normalizeEmails(data.emailsFacturas);
      data.emailsCertificados = normalizeEmails(data.emailsCertificados || data.emailsCertificados);
      data.emailsCertificados = data.emailsCertificados;

      // Normaliza y valida cuentas como [{iban, ...}] conservando campos adicionales
      let cuentas = data.cuentas || [];
      const clean = (s) => (s || '').replace(/\s+/g, '').toUpperCase();
      if (typeof cuentas === 'string') {
        cuentas = cuentas.split(';').map(s => clean(s)).filter(Boolean).map(iban => ({ iban }));
      }
      if (Array.isArray(cuentas)) {
        cuentas = cuentas.map(c => {
          if (typeof c === 'string') return { iban: clean(c) };
          return { ...c, iban: clean(c.iban) };
        }).filter(c => c.iban);
        // Eliminar duplicados por iban, conservando la primera aparición
        const seen = new Set();
        cuentas = cuentas.filter(c => { if (seen.has(c.iban)) return false; seen.add(c.iban); return true; });
      } else {
        cuentas = [];
      }
      const invalid = cuentas.filter(cta => !self.isValidIban(cta));
      if (invalid.length) {
        if (reject) reject('Revisa los IBAN: en la pestaña de <b>Pago y Finanzas</b> hay valores de IBAN <b style="color:red;">inválidos</b>.');
        return;
      }
      data.cuentas = cuentas;
      if (resolve) resolve(data);
    },

    // Históricos de Responsables y Empleado Ventas
    getHistoricoResponsables: function () {
      const self = this;
      return self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.historicoResponsable ? self.$refs.rform.formData.historicoResponsable : [];
    },
    mostrarHistoricoResponsables: function () {
      const self = this;
      self.popupHistoricoResponsablesOpened = true;
    },
    getHistoricoEmpleadoVentas: function () {
      const self = this;
      return self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.historicoEmpleadoVentas ? self.$refs.rform.formData.historicoEmpleadoVentas : [];
    },
    mostrarHistoricoEmpleadoVentas: function () {
      const self = this;
      self.popupHistoricoEmpleadoVentasOpened = true;
    },
    getHistoricoResponsableGestionCobro: function () {
      const self = this;
      return self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.historicoResponsableGestionCobro ? self.$refs.rform.formData.historicoResponsableGestionCobro : [];
    },
    mostrarHistoricoResponsableGestionCobro: function () {
      const self = this;
      self.popupHistoricoResponsableGestionCobroOpened = true;
    },
    verEnBC(bcId) {
      var self = this;
      var app = self.$f7;
      if (!bcId) {
        app.dialog.alert(self.$t('pedidos.bcId_no_disponible') || 'No hay bcId para este pedido.');
        return;
      }
      const baseUrl = process.env.VUE_APP_BC_WEB_URL || process.env.VUE_APP_BC_URL || '';
      if (!baseUrl) {
        app.dialog.alert('Configura VUE_APP_BC_WEB_URL para abrir el pedido en Business Central');
        return;
      }
      const environment = process.env.VUE_APP_BC_ENVIRONMENT ? `${process.env.VUE_APP_BC_ENVIRONMENT}/` : '';
      const company = process.env.VUE_APP_BC_COMPANY_ID;
      const companyParam = company ? `company=${encodeURIComponent(company)}` : '';
      const pageParam = 'page=21';
      const filterParam = `filter='$systemId' IS '${encodeURIComponent(bcId)}'`;
      const query = [companyParam, pageParam, filterParam].filter(Boolean).join('&');
      const url = `${baseUrl.replace(/\/$/, '')}/${environment}?${query}`;
      window.open(url, '_blank');
    },
    enviarBC(id) {
      var self = this;
      var app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Cliente.enviarBC({ itemId: id }).then(function (res) {
        self.$refs.rform.formData = res;
        espera.cerrar();
        app.toast
          .create({
            text: self.$t("pedidos.envio_bc_ok"),
            position: "center",
            closeTimeout: 2000,
            icon: '<i class="f7-icons">checkmark_alt</i>'
          })
          .open();
      }).catch(function (error) {
        espera.cerrar();
        app.dialog.alert(error.message);
      });
    },
  },
  created: function() {
    var self = this;
    var $ = self.$$;
    var $el = $(self.$el);
    var app = self.$f7;
    CondicionPago.getList({filter:{activa:true}}).then(function(res){
      self.condicionesPagoActivas = res.list;
    });
    Combos.getComboById("facturarComo").then(res => {
      self.facturarComo = res.list;
      self.$refs.facturarComo.reload(self.facturarComo);
    });
    self.idData = self.id;
  }
};
</script>

<style>
.list .item-input-outline .item-floating-label {
  border-radius: 7px;
}

/* Estilos para popups de históricos */
.popupHistoricoResponsables .list_popup,
.popupHistoricoEmpleadoVentas .list_popup,
.popupHistoricoResponsableGestionCobro .list_popup {
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.popupHistoricoResponsables .list_popup.row-header,
.popupHistoricoEmpleadoVentas .list_popup.row-header,
.popupHistoricoResponsableGestionCobro .list_popup.row-header {
  background-color: #f5f5f5;
  font-weight: bold;
  text-align: center;
}

.popupHistoricoResponsables .list_popup.row-even,
.popupHistoricoEmpleadoVentas .list_popup.row-even,
.popupHistoricoResponsableGestionCobro .list_popup.row-even {
  background-color: #f9f9f9;
}

.popupHistoricoResponsables .list_popup.row-odd,
.popupHistoricoEmpleadoVentas .list_popup.row-odd,
.popupHistoricoResponsableGestionCobro .list_popup.row-odd {
  background-color: #ffffff;
}

.popupHistoricoResponsables .list_popup .item-input-wrap,
.popupHistoricoEmpleadoVentas .list_popup .item-input-wrap,
.popupHistoricoResponsableGestionCobro .list_popup .item-input-wrap {
  margin: 0;
  padding: 4px 8px;
}

.popupHistoricoResponsables .list_popup input,
.popupHistoricoEmpleadoVentas .list_popup input,
.popupHistoricoResponsableGestionCobro .list_popup input {
  text-align: center;
  font-size: 14px;
  border: none;
  background: transparent;
}
</style>
